import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import TicketPrintForm from 'components/hiboutikForms/TicketPrintForm'
import TillForm from 'components/hiboutikForms/TillForm'
import SummaryComponent from './SummaryComponent'
import DueComponent from './DueComponent'
import NumPadComponent from 'components/numPad/NumPadComponent'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
const styles = theme => ({
  numPad: {}
})
export default withStyles(styles)(
  class PaymentComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      user: PropTypes.object.isRequired,
      transaction: PropTypes.object.isRequired,
      hist: PropTypes.object,
      paymentTypes: PropTypes.array.isRequired,
      addPayment: PropTypes.func.isRequired,
      removePayment: PropTypes.func.isRequired
    }
    state = {
      paidProducts: [],
      totalToAdd: 0
    }
    handlePrintClick = e => {
      this.refs.hb_form.submit()
    }
    handleClear = () => {
      this.setState({ totalToAdd: 0, paidProducts: [] })
    }
    handleRestClick = due => {
      this.setState({ totalToAdd: due, paidProducts: [] })
    }
    handleOnSelectProduct = product => {
      this.setState({
        paidProducts: [...this.state.paidProducts, product.key],
        totalToAdd: Number(this.state.totalToAdd) + Number(product.price)
      })
    }
    handleOnUnselectProduct = product => {
      let paidProducts = [...this.state.paidProducts]
      _.remove(paidProducts, p => p === product.key)
      this.setState({
        paidProducts: paidProducts,
        totalToAdd: Number(this.state.totalToAdd) - Number(product.price)
      })
    }
    handleOnSelectAllProducts = products => {
      let total = 0
      const paidPoducts = products.map(p => {
        total += Number(p.price)
        return p.key
      })
      this.setState({
        paidProducts: paidPoducts,
        totalToAdd: total
      })
    }

    addPaymentToTransaction = (value, type) => {
      const payment = {
        type: type,
        amount: value,
        paidProducts: this.state.paidProducts
      }
      if (this.props.hist) {
        this.props.addPayment(this.props.hist, payment)
      } else {
        this.props.addPayment(this.props.transaction, payment)
      }
      this.setState({ totalToAdd: 0 })
    }
    removePaymentFromTransaction = payment => {
      if (this.props.hist) {
        this.props.removePayment(this.props.hist, payment)
      } else {
        this.props.removePayment(this.props.transaction, payment)
      }
    }
    isPrintDisabled = transaction => {
      let printEnabled = true
      const products = transaction.products ? transaction.products : {}
      Object.keys(products).map(key => {
        if (printEnabled === true && !products[key].id_sale_product_detail) {
          printEnabled = false
        }
        return null
      })
      if (
        printEnabled &&
        transaction.pool &&
        !transaction.pool.id_sale_product_detail
      ) {
        printEnabled = false
      }
      if (
        printEnabled &&
        transaction.pool &&
        transaction.pool.transfert &&
        !transaction.pool.transfert.id_sale_product_detail
      ) {
        printEnabled = false
      }
      if (printEnabled && transaction.pool && !transaction.pool.sync) {
        printEnabled = false
      }
      console.log('Transaction : ', transaction)
      console.log('PrintEnabled : ', !printEnabled)
      return !printEnabled
    }
    render() {
      const { classes, transaction, user } = this.props
      const { totalToAdd } = this.state
      const payments = transaction.payments
        ? Object.keys(transaction.payments)
            .map(key => ({ ...transaction.payments[key], key: key }))
            .reverse()
        : []
      let totalPaid = 0
      for (const p of payments) {
        totalPaid += Number(p.amount)
      }
      const due = Number(transaction.total) - Number(totalPaid)
      return (
        <Grid
          item
          xs={12}
          container
          direction="row"
          alignItems="flex-start"
          justify="space-between"
          spacing={8}>
          <Grid item xs={12} sm={6}>
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignItems="center"
              justify="space-between"
              spacing={0}>
              <Grid item>
                <TicketPrintForm
                  disabled={this.isPrintDisabled(transaction)}
                  saleId={transaction.sale_id}
                  hiboutikAccount={user.hiboutikAccount}
                />
              </Grid>
              <Grid item>
                <TillForm hiboutikAccount={user.hiboutikAccount} />
              </Grid>
            </Grid>
            <Grid style={{ marginTop: 10 }} item xs={12}>
              <SummaryComponent
                transaction={transaction}
                payments={payments}
                onSelectProduct={this.handleOnSelectProduct}
                onUnselectProduct={this.handleOnUnselectProduct}
                onSelectAllProducts={this.handleOnSelectAllProducts}
              />
            </Grid>
            <Grid style={{ marginTop: 10 }} item xs={12}>
              <DueComponent
                payments={payments}
                due={due}
                onRestClick={this.handleRestClick}
                removePayment={this.removePaymentFromTransaction}
              />
            </Grid>
          </Grid>
          <Grid className={classes.numPad} item xs={12} sm={6}>
            <NumPadComponent
              onClear={this.handleClear}
              paymentTypes={this.props.paymentTypes}
              addPayment={this.addPaymentToTransaction}
              disabled={totalToAdd > 0}
              credEnabled={!!transaction.customer}
              total={totalToAdd < 0 ? 0 : totalToAdd}
            />
          </Grid>
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/payment/PaymentComponent.js